<template>
  <nav class="mobile-bottom-bar d-xl-none" id="mobile-bottom-bar">
    <!-- Главная -->
    <button
      class="mobile-bottom-bar__item"
      :class="{ 'mobile-bottom-bar__item--active': $route.path === '/' }"
      @click="goHome"
    >
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M3 8.5L10 2L17 8.5V17C17 17.5523 16.5523 18 16 18H13V13H7V18H4C3.44772 18 3 17.5523 3 17V8.5Z" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
      </svg>
      <span>{{ $t('Menu.MobileHome') }}</span>
    </button>

    <!-- Меню -->
    <button
      class="mobile-bottom-bar__item"
      :class="{ 'mobile-bottom-bar__item--active': sidebarOpen }"
      @click="toggleMenu"
    >
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M3 5H17M3 10H17M3 15H17" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
      </svg>
      <span>{{ $t('Menu.MobileMenu') }}</span>
    </button>

    <!-- Отчеты -->
    <button
      class="mobile-bottom-bar__item"
      :class="{ 'mobile-bottom-bar__item--active': isReportsActive }"
      @click="openReports"
    >
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M3 14L7.5 9L11 12.5L14.5 7L17 9.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <rect x="3" y="3" width="14" height="14" rx="2" stroke="currentColor" stroke-width="2"/>
      </svg>
      <span>{{ $t('Menu.Reports') }}</span>
    </button>

    <!-- Профиль -->
    <button
      class="mobile-bottom-bar__item"
      :class="{ 'mobile-bottom-bar__item--active': $route.path === '/profile' }"
      @click="goProfile"
    >
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="10" cy="7" r="3.5" stroke="currentColor" stroke-width="2"/>
        <path d="M3.5 17C3.5 14.0147 6.46243 11.5 10 11.5C13.5376 11.5 16.5 14.0147 16.5 17" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
      </svg>
      <span>{{ $t('Menu.MobileProfile') }}</span>
    </button>

    <!-- Чат -->
    <button
      class="mobile-bottom-bar__item"
      @click="toggleChat"
    >
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M3 4C3 3.44772 3.44772 3 4 3H16C16.5523 3 17 3.44772 17 4V13C17 13.5523 16.5523 14 16 14H7L3 17V4Z" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
      </svg>
      <span>{{ $t('Menu.MobileChat') }}</span>
    </button>

  </nav>
</template>

<script>
export default {
  name: 'MobileBottomBar',
  computed: {
    sidebarOpen() {
      return this.$store.state.theme.mobileSidebarOpen;
    },
    isReportsActive() {
      return this.$route.path.startsWith('/user-reports') || this.$route.path.startsWith('/report-builder');
    }
  },
  methods: {
    goHome() {
      if (this.$route.path !== '/') {
        this.$router.push('/');
      }
    },
    toggleMenu() {
      this.$store.commit('theme/toggleMobileSidebar');
    },
    openReports() {
      this.$store.commit('theme/openMobileSidebarWithReports');
    },
    goProfile() {
      if (this.$route.path !== '/profile') {
        this.$router.push('/profile');
      }
    },
    toggleChat() {
      if (window.$chatwoot) {
        window.$chatwoot.toggle();
      }
    }
  }
};
</script>

<style scoped>
.mobile-bottom-bar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1040;
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  grid-template-rows: 53px;
  padding-bottom: env(safe-area-inset-bottom, 18px);
  height: calc(72px + env(safe-area-inset-bottom, 0px));
  background-color: rgba(255, 255, 255, 0.92);
  backdrop-filter: saturate(1.8) blur(20px);
  -webkit-backdrop-filter: saturate(1.8) blur(20px);
  border-top: 1px solid rgb(236, 238, 243);
}

.mobile-bottom-bar__item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  height: 53px;
  padding: 10px 4px 6px;
  row-gap: 3px;
  border: none;
  background: transparent;
  cursor: pointer;
  color: rgb(138, 142, 156);
  font-size: 10px;
  font-weight: 600;
  line-height: 1;
  transition: color 0.18s ease;
  -webkit-tap-highlight-color: transparent;
  outline: none;
}

.mobile-bottom-bar__item svg {
  flex-shrink: 0;
  transition: transform 0.15s ease;
}

.mobile-bottom-bar__item:active svg {
  transform: scale(0.9);
}

.mobile-bottom-bar__item--active {
  color: rgb(52, 56, 177);
}

/* Dark mode */
:root[data-theme="dark"] .mobile-bottom-bar,
.dark-version .mobile-bottom-bar {
  background-color: rgba(20, 22, 36, 0.94);
  border-top-color: rgba(255, 255, 255, 0.08);
}

:root[data-theme="dark"] .mobile-bottom-bar__item,
.dark-version .mobile-bottom-bar__item {
  color: rgba(160, 166, 185, 0.9);
}

:root[data-theme="dark"] .mobile-bottom-bar__item--active,
.dark-version .mobile-bottom-bar__item--active {
  color: rgb(99, 104, 230);
}

@media (min-width: 1200px) {
  .mobile-bottom-bar {
    display: none !important;
  }
}
</style>

<!-- Global styles for safe-area padding and Chatwoot override -->
<style>
@media (max-width: 1199.98px) {
  .main-content {
    padding-bottom: calc(72px + env(safe-area-inset-bottom, 0px)) !important;
  }

  /* Hide the default Chatwoot FAB — we use our own bottom bar button */
  .woot-widget-bubble,
  .woot--bubble-holder {
    display: none !important;
  }

  /* When chat is open: expand widget to fill the full viewport */
  .woot-widget-holder {
    width: 100% !important;
    max-width: 100% !important;
    height: 100% !important;
    max-height: 100vh !important;
    bottom: 0 !important;
    right: 0 !important;
    border-radius: 0 !important;
  }
}
</style>
